module.exports = __webpack_public_path__ + "img/Hängepartie.3b2d9935.svg";